// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { ArticuloUnidadMedidaProps } from '../../../interfaces/articuloUnidadMedida.ts'

const query = gql`
  query ARTICULO_UNIDAD_MEDIDA {
    articuloUnidadMedidaListado(limit: 10000) {
      docs {
        _id
        codigoUnidadMedida
        nombreUnidadMedida
      }
    }
  }
`

export const apiArticuloUnidadMedidaListado = async (): Promise<
  ArticuloUnidadMedidaProps[]
> => {
  const client = new GraphQLClient(import.meta.env.ISI_API_URL)
  const token = localStorage.getItem(AccessToken)
  // Set a single header
  client.setHeader('authorization', `Bearer ${token}`)

  const data: any = await client.request(query)
  return data.articuloUnidadMedidaListado.docs
}
